import {
  getMerchantById,
  Merchant,
  MerchantStatus,
  patchChangeMerchantStatusByMerchantId,
} from '@nemuru-eng/js-api-client';

import { ActionMessage } from '@/components/widgets/MerchantDetailActions/components/ActionMessage';
import { MerchantDetailAction } from '@/components/widgets/MerchantDetailActions/types/MerchantDetailAction';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface ChangeMerchantStatusProps {
  merchant: Merchant;
  newMerchantStatus: MerchantStatus;
  currentAction: MerchantDetailAction;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose: () => void;
}
export const ChangeMerchantStatus = ({
  merchant,
  newMerchantStatus,
  currentAction,
  opened,
  setOpened,
  handleClose,
}: ChangeMerchantStatusProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getMerchantById, { merchantId: merchant.id });

  const onSubmit = async () => {
    await request(patchChangeMerchantStatusByMerchantId, {
      id: merchant.id,
      merchantStatus: newMerchantStatus,
    });
    handleClose();
    revalidate();
  };

  return (
    <ActionMessage
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      currentAction={currentAction}
      onSubmit={onSubmit}
      isLoading={loading}
    />
  );
};
